import { matchPath } from 'react-router-dom';

import type { AuditLogRowView } from 'api/project-audit/types';
import { buildProjectPath, projectPaths } from 'app/routes/paths/project';

// Audit is live-only, so there are no proposal variants.
export const auditBaseRoutePath = `${projectPaths.BASE}/audit`;
export const auditDetailRoutePath = `${auditBaseRoutePath}/t/:templateNodeId/d/:id/details`;

// Only marks which entry opened the panel, so its row can be highlighted.
export const AUDIT_ENTRY_PARAM = 'entry';

type AuditNodeDetailsRouteParams = { projectId: string; templateNodeId: string; id: string };

export const matchAuditNodeDetailsPath = (pathname: string) =>
  matchPath<AuditNodeDetailsRouteParams>(pathname, { path: auditDetailRoutePath });

export const buildAuditPath = (projectId: string) => `${buildProjectPath(projectId)}/audit`;

export const buildAuditNodeDetailsPath = (projectId: string, row: AuditLogRowView) =>
  `${buildAuditPath(projectId)}/t/${row.templateNodeId}/d/${row.nodeId}/details?${AUDIT_ENTRY_PARAM}=${row.id}`;
